<template>
      <check-in-screen>
            <div class="text-center">
            <h2>{{$t('thanks.title')}}</h2>
            <hr>
            <h4>{{$t('thanks.messageText')}}</h4>
            </div>
      </check-in-screen>
</template>

<script>
import CheckInScreen from '@/components/layout/CheckInScreen'

export default {
    name: 'Thanks',
    components: {
        CheckInScreen,
    },
    mounted(){
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }
}
</script>

<style scoped>

</style>
